import { useMutation, useQuery } from '@apollo/client';
import { useSnackbar } from '@components/Snackbar/SnackbarProvider';
import { ADD_UPERCUT, GET_UPERCUTS } from '@gql/upercut';
import { GET_UPERCUT_ROLES } from '@gql/upercut-permissions';
import { Box } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import UpercutForm from '../../modules/upercut/UpercutForm';
import { UpercutFormValues } from '../../modules/upercut/types';

interface RoleOption {
    _id: string;
    name: string;
}

const CreateUpercutPage = () => {
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();

    const formMethods = useForm<UpercutFormValues>({
        mode: 'onChange',
        defaultValues: {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            passwordConfirm: '',
            roleId: '',
        },
    });

    const [addUpercut, { loading: isCreating }] = useMutation(ADD_UPERCUT);

    const { data: rolesData } = useQuery(GET_UPERCUT_ROLES, {
        fetchPolicy: 'cache-and-network',
    });
    const roles: RoleOption[] = rolesData?.upercutRoles ?? [];

    const handleSubmit = async (values: UpercutFormValues) => {
        try {
            const upercutInput: any = {
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                password: values.password,
                passwordConfirm: values.passwordConfirm,
            };
            if (values.roleId) {
                upercutInput.roleId = values.roleId;
            }
            await addUpercut({
                variables: { upercutInput },
                refetchQueries: [
                    { query: GET_UPERCUTS, variables: { limit: 10, offset: 0, filter: null } },
                ],
                awaitRefetchQueries: true,
            });
            showSnackbar('Utilisateur Upercut créé avec succès.', 'success');
            navigate('/upercuts');
        } catch (err: any) {
            showSnackbar(err?.message || "Échec de la création de l'utilisateur.", 'error');
        }
    };

    return (
        <Box p={3}>
            <UpercutForm
                formMode="create"
                formMethods={formMethods as any}
                onSubmit={handleSubmit as any}
                onCancel={() => navigate('/upercuts')}
                isSubmitting={isCreating}
                roles={roles}
            />
        </Box>
    );
};

export default CreateUpercutPage;
